/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/web'
export default icon
